import React from 'react';
import PropTypes from 'prop-types';
import { PaymentElement } from '@stripe/react-stripe-js';
import { paymentElementOptions } from '../../../shared/stripePaymentElementOptions';

const CheckoutPaymentSection = ({ stripeError, stripeErrorRef, defaultCountry }) => (
  <div className="row"
       style={{"marginTop": "23px"}}>
    <div className="col-12">
      <p className="mb-0 mb-3"
         style={{"fontSize": "16px"}}>
        <strong>Payment method</strong>
      </p>
    </div>
    <div className="col-12">
      {Object.keys(stripeError).length > 0 ? (
        <div ref={stripeErrorRef} className="alert alert-danger border-0 text-white"
             style={{"background": "#FF4C00"}}
             role="alert">
          {stripeError.message}
        </div>
      ) : null}
      <PaymentElement options={paymentElementOptions(defaultCountry ? {
        defaultValues: {
          billingDetails: {
            address: {
              country: defaultCountry
            }
          }
        }
      } : {})} />
    </div>
  </div>
);

CheckoutPaymentSection.propTypes = {
  stripeError: PropTypes.object.isRequired,
  stripeErrorRef: PropTypes.object.isRequired,
  defaultCountry: PropTypes.string,
};

export default CheckoutPaymentSection;
